import { Action, AsyncState, IOWidget, mk_widget, Pair } from 'widgets-for-react'
import { Link } from 'react-router-dom'
import { Map } from 'immutable'
import React from 'react'

import { ImageContainer } from './ImageContainer.gen'
import { CookieSensitiveContentWrapper } from '../cookiebar.mod'
import { getClassName } from '../utils.gen'
import { ImageSize, CMSState } from '../types.gen'
import Plyr from 'react-plyr'
import { acceptCookies } from '../cookiebar.utils.mod'

export type MediaBlockProps<extra_images> = {
  kind_media: 'image' | 'video'
  image?: number
  image_alt?: string
  size?: ImageSize<extra_images>
  get_default_data_src: () => ImageSize<extra_images>
  get_default_data_srcset: () => Pair<ImageSize<extra_images>, string>[]
  video?: {
    url?: string
    id: string
    type: 'youtube' | 'vimeo' | 'video' | 'audio'
    width: string
    height: string
    frameBorder: string
    allowFullScreen: boolean
  }
  caption?: string
  useCookieBar: boolean
}

export type MediaBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
  figure_classname: string
  media_classname: string
  image_classname: string
  placeholder_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export function MediaBlock<CustomBlockData, extra_images>(
  props: MediaBlockProps<extra_images>,
  options?: { style?: MediaBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, never>, Action<CMSState<CustomBlockData, extra_images, never>>> {
  return (cmsState: CMSState<CustomBlockData, extra_images, never>) =>
    mk_widget({
      run: _ => {
        return (
          <section
            className={getClassName(options, 'block_classname', 'container')}
            key={options && options.key ? options.key : 'media-block'}
          >
            <div className={getClassName(options, 'inner_classname', 'py-5')}>
              <div className={getClassName(options, 'content_classname', '')}>
                <figure className={getClassName(options, 'figure_classname', '')}>
                  {props.kind_media === 'image' && props.image != null ? (
                    cmsState.images.has(props.image) ? (
                      <div className={getClassName(options, 'media_classname', '')}>
                        {ImageContainer(
                          cmsState.images.get(props.image) as AsyncState<Map<ImageSize<extra_images>, string>>,
                          props.size,
                          getClassName(options, 'image_classname', 'w-100'),
                          props.image_alt,
                          props.get_default_data_src,
                          props.get_default_data_srcset
                        ).run(_ => {})}
                      </div>
                    ) : (
                      <div className={getClassName(options, 'placeholder_classname', '')} aria-hidden="true" />
                    )
                  ) : (
                    props.kind_media === 'video' &&
                    props.video != undefined && (
                      <div className={getClassName(options, 'media_classname', 'text-center')}>
                        {props.useCookieBar ? (
                          <CookieSensitiveContentWrapper
                            options={{
                              style:
                                options && options.style
                                  ? {
                                      cookies_classname: options.style.cookies_classname,
                                      cookies_inner_classname: options.style.cookies_inner_classname,
                                      cookies_text_classname: options.style.cookies_text_classname,
                                      cookies_clickable_classname: options.style.cookies_clickable_classname
                                    }
                                  : undefined
                            }}
                            placeholder={
                              <>
                                Wijzig je cookievoorkeuren om deze video te bekijken in Compleet of Noodzakelijk.{' '}
                                <Link to="/cookies">Meer informatie over cookies</Link><button className="btn btn--primary" onClick={() => acceptCookies('complete')}>Accepteer cookies</button>
                              </>
                            }
                          >
                            <Plyr type={props.video.type} videoId={props.video.id} />
                          </CookieSensitiveContentWrapper>
                        ) : (
                          <Plyr type={props.video.type} videoId={props.video.id} />
                        )}
                      </div>
                    )
                  )}

                  {props.caption && (
                    <figcaption className={getClassName(options, 'figcaption_classname', '')}>
                      <p
                        className={getClassName(options, 'caption_classname', 'small text-secondary text-center mt-2')}
                      >
                        {props.caption}
                      </p>
                    </figcaption>
                  )}
                </figure>
              </div>
            </div>
          </section>
        )
      }
    })
}



// WEBPACK FOOTER //
// ./Client/components/cms/blocks/widgets/mediaBlock.gen.tsx